import { Link } from "react-router-dom";
import { PageHeader, Section, DividerGold } from "@/components/layout/Section";
import { APOSTLE_IMAGE } from "@/constants/branding";
import { ArrowRight, BookOpen, Flame, Users, HeartHandshake } from "lucide-react";

export default function Overseer() {
  return (
    <div data-testid="overseer-page">
      <PageHeader
        kicker="Meet the General Overseer"
        title="Apostle Percy Konotey"
        subtitle="A minister of the Word, a father to many, and a vessel God is using to raise disciples of Christ around the world."
      />

      <Section>
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="aspect-[4/5] rounded-[2.5rem] overflow-hidden shadow-2xl border-4 border-white">
                <img src={APOSTLE_IMAGE} alt="Apostle Percy Konotey" className="w-full h-full object-cover" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-gold text-royal-800 rounded-2xl px-6 py-4 shadow-xl">
                <div className="text-[10px] uppercase tracking-widest">General Overseer</div>
                <div className="font-serif text-xl">Apostle Percy Konotey</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="kicker mb-4">Biography</div>
            <h2 className="font-serif text-4xl text-royal-800 tracking-tight leading-tight">
              A life set apart for the Gospel of Jesus Christ.
            </h2>

            <div className="mt-8 space-y-5 text-slate-600 leading-relaxed">
              <p>
                Apostle Percy Konotey is the General Overseer of Christ Love Breed Church — a Spirit-filled minister whose life bears witness to the grace, wisdom, and power of God.
              </p>
              <p>
                Known for his sound teaching of the Scriptures, prophetic insight, and pastoral heart, Apostle Percy has devoted himself to raising a generation of Christ-loving disciples who carry the presence and purpose of God into every sphere of life.
              </p>
              <p>
                Through weekly services, encounter meetings, conferences and outreach, the Lord continues to use his ministry to break chains, restore hope, and birth Kingdom destinies in the lives of thousands.
              </p>
            </div>

            <div className="mt-10 grid sm:grid-cols-2 gap-4">
              {[
                { icon: BookOpen, t: "Apostolic Teaching", d: "Deep, biblical, and Christ-centered." },
                { icon: Flame, t: "Prophetic Ministry", d: "A voice that clarifies and confirms God's counsel." },
                { icon: Users, t: "Discipleship", d: "Raising sons and daughters, not just crowds." },
                { icon: HeartHandshake, t: "Compassion", d: "A father's heart — pastoral, patient, prayerful." },
              ].map((h) => (
                <div key={h.t} className="p-5 rounded-2xl border border-gold/20 bg-white">
                  <div className="w-9 h-9 rounded-full bg-gold/15 text-gold-500 flex items-center justify-center">
                    <h.icon className="w-4 h-4" />
                  </div>
                  <div className="mt-3 font-serif text-lg text-royal">{h.t}</div>
                  <div className="text-slate-500 text-sm mt-1">{h.d}</div>
                </div>
              ))}
            </div>

            <div className="mt-10">
              <Link to="/sermons" className="btn-primary">Listen to His Sermons <ArrowRight className="w-4 h-4" /></Link>
            </div>
          </div>
        </div>
      </Section>

      <Section className="bg-royal-800 text-white rounded-[3rem] mx-4">
        <div className="max-w-3xl mx-auto text-center">
          <DividerGold />
          <blockquote className="mt-8 font-serif italic text-2xl sm:text-3xl leading-snug text-white/90">
            "God is not looking for perfect people; He is looking for surrendered people. Say yes to Him, and watch what your yes will birth."
          </blockquote>
          <div className="mt-6 text-gold text-sm tracking-[0.25em] uppercase">— Apostle Percy Konotey</div>
        </div>
      </Section>
    </div>
  );
}
